import { styled } from '@linaria/react';

export const Image = styled.img`
  display: block;
`;
